const { createContext, useState } = require('react');

/**
 * @typedef {import('../api/auth/login').TLogin | null} TAuth
 *
 * @typedef {object} TAuthContext
 * @property {TAuth} auth
 * @property {() => void} setAuth
 * @property {boolean} persist
 * @property {() => void} setPersist
 */

const rawPersisit = window.localStorage.getItem('persist');

const AuthContext = createContext({
  auth: null,
  setAuth: () => {},
  persist: rawPersisit,
  setPersist: () => {},
});

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(null);
  const [persist, setPersist] = useState(Boolean(rawPersisit));

  const handleSetPersist = (value) => {
    console.log(value);
    setPersist(value);
    window.localStorage.setItem('persist', value);
  };

  const value = {
    auth,
    setAuth,
    persist,
    setPersist: handleSetPersist,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthContext;
